import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { resetPassword /* <- new */, sendPasswordConfirmation } from "../../api";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import logo from "../../Resources/Transparent_Logo.png";
import Spinner from "react-bootstrap/Spinner";

export default function PasswordReset() {
  const [errorAlert, setErrorAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [errorText, setErrorText] = useState(""); // optional: show real error
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ password1: "", password2: "" });

  const navigate = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const tokenId = params.get("tokenId");
  const token = params.get("token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
    setErrorAlert(false);
    setSuccessAlert(false);
    setErrorText("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorAlert(false);
    setSuccessAlert(false);
    setErrorText("");

    // ✅ Validate link params exist
    if (!tokenId || !token) {
      setErrorAlert(true);
      setErrorText("This reset link is invalid or incomplete. Please request a new one.");
      return;
    }

    if (data.password1 !== data.password2) {
      setErrorAlert(true);
      setErrorText("Your passwords don't match.");
      return;
    }

    try {
      setLoading(true);

      const response = await resetPassword(tokenId, token, data.password1);

      if (response?.status === 200) {
        setSuccessAlert(true);
        setTimeout(() => navigate("/login"), 1200);
      }
    } catch (err) {
      setErrorAlert(true);
      const msg = err?.response?.data?.message;
      if (msg) {
        setErrorText(msg);
      } else if (err?.response?.status === 429) {
        setErrorText("Too many attempts. Please wait 15 minutes and try again.");
      } else {
        setErrorText("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClose = () => {
    setErrorAlert(false);
    setSuccessAlert(false);
    setErrorText("");
    setData({ password1: "", password2: "" });
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100">
      <div className="shadow-sm p-4 bg-white rounded w-100 mx-3" style={{ maxWidth: 480 }}>
        <div className="text-center">
          <img src={logo} alt="Logo" style={{ width: "100px", height: "80px" }} />
          <h5 className="mt-3 text-primary mb-2">Reset Password</h5>
          <p className="small text-muted">Please enter a new password.</p>
        </div>

        {errorAlert && (
          <Alert variant="danger" dismissible onClose={handleCancelClose}>
            {errorText || "Something went wrong."}
          </Alert>
        )}

        {successAlert && (
          <Alert variant="success" dismissible onClose={handleCancelClose}>
            Your password was updated successfully.
          </Alert>
        )}

        <Form onSubmit={handleSubmit} className="mt-3">
          <Row className="mb-3">
            <Col>
              <Form.Group controlId="password1">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  required
                  type="password"
                  name="password1"
                  value={data.password1}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Group controlId="password2">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  required
                  type="password"
                  name="password2"
                  value={data.password2}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col className="d-flex justify-content-center">
              <Button variant="primary" type="submit" className="w-50" disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" role="status" /> : "Submit"}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
}
